import React, { ChangeEvent } from 'react';
import Modal from 'react-modal';
import styles from './TrainingCompleteDialog.module.scss';

type Props = {
  // 表示するか
  isOpen: boolean;
  // 次のトレーニングのボタン名
  nextTrainingButtonTitle: string;
  // CompleteCheckBoxが見えるかどうか
  isCompleteCheckboxVisible: boolean;
  // Close Button
  onClickCloseButton: () => void;
  // Repeat
  onClickRepeat: () => void;
  // Topic Select
  onClickTopicSelect: () => void;
  // Next Mode / Next Topic
  onClickNext: () => void;
  // CompleteCheckboxの変更イベント
  onChangeCompleteCheckbox: (event: ChangeEvent<HTMLInputElement>) => void;
  // CompleteCheckBox
  completeCheckBoxChecked: boolean;
};

const TrainingCompleteDialog = React.memo<Props>((props) => {
  const {
    isOpen,
    nextTrainingButtonTitle,
    isCompleteCheckboxVisible,
    completeCheckBoxChecked,
    onClickCloseButton,
    onClickRepeat,
    onClickTopicSelect,
    onClickNext,
    onChangeCompleteCheckbox,
  } = props;

  return (
    <Modal
      className={styles['training-complete-dialog']}
      isOpen={isOpen}
      overlayClassName={styles.overlay}
    >
      <div className={styles['training-complete-dialog-container']}>
        <div
          className={`${styles['training-complete-dialog-header']} ${styles['mod-close-btn']}`}
        >
          <div className={styles['training-complete-dialog-header-right']}>
            <button
              type="button"
              onClick={onClickCloseButton}
              className={styles['close-btn']}
            >
              <figure>
                <div
                  className={`${styles['svg-icon']} ${styles['ic-close']}`}
                />
              </figure>
            </button>
          </div>
        </div>

        <div className={styles['training-complete-dialog-content']}>
          <button
            type="button"
            onClick={onClickNext}
            className={`${styles['training-complete-dialog-button']} ${styles['mod-vertical']}`}
          >
            {nextTrainingButtonTitle}
          </button>
          <button
            type="button"
            onClick={onClickRepeat}
            className={`${styles['training-complete-dialog-button']} ${styles['mod-vertical']}`}
          >
            Repeat
          </button>
          <button
            type="button"
            onClick={onClickTopicSelect}
            className={`${styles['training-complete-dialog-button']} ${styles['mod-vertical']} ${styles.bottom} ${styles['mod-bordered']}`}
          >
            Topic Select
          </button>
        </div>
        {isCompleteCheckboxVisible && (
          <div
            className={`${styles['training-complete-dialog-content']} ${styles['mod-footer-checkbox']}`}
          >
            <div
              className={`${styles['training-complete-dialog-footer']} ${styles['mod-center']}`}
            >
              <div className={styles['app-checkbox']}>
                <input
                  checked={completeCheckBoxChecked}
                  onChange={onChangeCompleteCheckbox}
                  type="checkbox"
                  id="training-complete-dialog-complete-checkbox"
                />
                <label htmlFor="training-complete-dialog-complete-checkbox">
                  Complete
                </label>
              </div>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
});

export default TrainingCompleteDialog;
